import { findKey, filter } from 'lodash';
import { FORUM_APP_ID } from '../constants/applications';
import biLogger from '@wix/web-bi-logger';
import * as CARD_SIZES from '../constants/card-sizes';
import * as LAYOUT_TYPES from '../constants/layout-types';
import * as CATEGORY_TEXT_ALIGNMENT from '../constants/text-alignment';
import Wix from '../services/wix-sdk-polyfill';
import { getLocation, getPrevPath } from '../../common/store/location/location-selectors';
import detectRoute, { POST_PAGE, FEED_PAGE, routeMap } from '../services/detect-route';

export function getReferrer(state) {
  return detectRoute(getPrevPath(state));
}

export function getCurrentOrigin(state) {
  return detectRoute(getLocation(state));
}

export function createBi({ endpoint, src, instanceId }) {
  return biLogger
    .factory({ endpoint })
    .setDefaults({
      src,
      app_id: FORUM_APP_ID,
      app_site_id: instanceId,
      instance_id: instanceId,
    })
    .logger();
}

export function createUouBi({ endpoint, src, instanceId }) {
  return biLogger
    .factory({ endpoint })
    .updateDefaults({
      src,
      app_id: FORUM_APP_ID,
      app_site_id: instanceId,
      instance_id: instanceId,
    })
    .logger();
}

export function getLayoutName(id) {
  id = parseInt(id, 10);
  return findKey(LAYOUT_TYPES, type => type === id).toLowerCase();
}

export function getCardSizeName(id) {
  id = parseInt(id, 10);
  return findKey(CARD_SIZES, type => type === id).toLowerCase();
}

export function getTextAlignmentName(id) {
  id = parseInt(id, 10);
  return findKey(CATEGORY_TEXT_ALIGNMENT, type => type === id).toLowerCase();
}

export function getImageCount(entity) {
  const content = entity.content;
  return filter(content.entityMap, entity => entity.type === 'wix-draft-plugin-image').length;
}

export function getHashtagCount(entity) {
  const hashtags = entity.hashtags || [];
  return hashtags.length;
}

export function getEmojiCount(entity) {
  const content = entity.content;
  return filter(content.entityMap, entity => entity.type === 'emoji').length;
}

export function getMentionCount(entity) {
  const content = entity.content;
  return filter(content.entityMap, entity => entity.type === 'mention').length;
}

export function getQuoteCount(entity) {
  const content = entity.content;
  return filter(content.blocks, entity => entity.type === 'blockquote').length;
}

export function getVideoCount(entity) {
  const content = entity.content;
  return filter(
    content.entityMap,
    entity => entity.type === 'wix-draft-plugin-video' || entity.type === 'VIDEO-EMBED',
  ).length;
}

export function hasBiToken(event) {
  return !!event.biToken;
}

export function isNotDummyVisitorId(event) {
  return event.visitor_id !== '00000000-0000-0000-0000-000000000000';
}

export function isNotEditor() {
  return Wix.Utils.getViewMode() !== 'editor';
}

export function hasMemberId(event) {
  return !!event.member_id;
}
